import { render, staticRenderFns } from "./LabellingTool.vue?vue&type=template&id=3a015834&scoped=true&"
import script from "./LabellingTool.vue?vue&type=script&lang=js&"
export * from "./LabellingTool.vue?vue&type=script&lang=js&"
import style0 from "./LabellingTool.vue?vue&type=style&index=0&id=3a015834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a015834",
  null
  
)

export default component.exports